// DEPRECATED: il default arriva dal backend
export const creatorJson = {
  locale: 'it',
  widthMode: 'responsive',
  pages: [
    {
      name: 'informativa-privacy',
      elements: [
        {
          type: 'html',
          name: 'privacy_text',
          html: "Ai sensi del decreto legislativo D.Lgs. 196/2003, il trattamento dei dati personali da lei forniti avverrà esclusivamente ai fini della risposta alla presente istanza, compresa la comunicazione ad altri uffici di questa stessa amministrazione. Le ricordiamo che in ogni momento potrà chiedere all'ente, la correzione, l'aggiornamento o la cancellazione dei suoi dati.",
        },
        {
          type: 'checkbox',
          name: 'privacy',
          title: 'Informativa sulla privacy',
          isRequired: true,
          requiredErrorText:
            "E' necessario accettare l'informativa sulla privacy",
          choices: [
            {
              value: 'consenso',
              text: 'Acconsento',
            },
          ],
        },
      ],
      isRequired: true,
      title: 'Informativa sulla privacy',
      navigationTitle: 'Informativa sulla privacy',
    },
    {
      name: 'dati-richiedente',
      elements: [
        {
          type: 'panel',
          name: 'dati-del-richiedente',
          elements: [
            {
              type: 'text',
              name: 'fullname',
              title: 'Il/La sottoscritto',
              isRequired: true,
              valueName: 'fullname',
              readOnly: true,
            },
            {
              type: 'text',
              name: 'email',
              title: 'Mail di registrazione',
              isRequired: true,
              inputType: 'email',
              valueName: 'email',
            },
          ],
          title: 'Dati del richiedente',
        },
      ],
      isRequired: true,
      title: 'Informazioni generali del richiedente',
      navigationTitle: 'Informazioni generali del richiedente',
    },
  ],
  showQuestionNumbers: 'off',
  showPreviewBeforeComplete: 'showAllQuestions',
  pagePrevText: 'Indietro',
  pageNextText: 'Avanti',
  completeText: 'Invia',
  previewText: 'Riepilogo',
  editText: 'Modifica',
  startSurveyText: 'Inizia la compilazione',
  showProgressBar: 'top',
  progressBarType: 'buttons',
  questionErrorLocation: 'bottom',
  showPageTitles: 'false',
  showPageNumbers: 'false',
  clearInvisibleValues: 'onHidden',
  textUpdateMode: 'onTyping',
  navigateToUrl: '', //al termine della compilazione della form, naviga a questo url anziche mostrare la pagina di 'Form completata'.
  navigateToUrlOnCondition: null, //al termine della compilazione della form, naviga a questo url anziche mostrare la pagina di 'Form completata' se vengono soddisfatte le condizioni indicate in questa prop.
  showCompletedPage: true,
  completedHtml: ' ', //da compilare se non si setta 'navigateToUrl'
  completedHtmlOnCondition: [],
  loadingHtml: '<h3>Attendere...</h3>',
};

export const creatorOptions = {
  //https://github.com/surveyjs/survey-creator/blob/d1044b913265d7577f013ce69f0088a07a56ef03/packages/survey-creator-core/src/creator-options.ts
  haveCommercialLicense: true,
  showDesignerTab: true,
  showPreviewTab: false,
  showLogicTab: true, //Displays the Logic tab in the tab panel.
  showJSONEditorTab: false,
  showEmbeddedSurveyTab: false,
  showTranslationTab: false,
  isAutoSave: false, //Automatically saves the survey JSON schema on every change.
  showObjectTitles: 10, //Limits the number of visible choices. Users can click "Show more" to view hidden choices. Set this property to -1 if you do not want to hide any choices.
  questionTypes: [
    'text',
    'comment',
    'checkbox',
    'radiogroup',
    'dropdown',
    'file',
    'html',
    'panel',
    'paneldynamic',
    //'boolean',
    //'expression',
    //'image',
    //'imagepicker',
    //'matrix',
    //'matrixdropdown',
    //'matrixdynamic',
    //'multipletext',
    // 'rating',
    // 'ranking',
    //'signaturepad',
  ],
};

/*
  Removes properties from sidebar and from form.
 All properties are here: https://surveyjs.io/form-library/documentation/surveymodel#data

  //Examples:
  /*
  //remove a property to the page object. You can't set it in JSON as well
  'panelbase':['visibleIf'];
  //remove a property from the base question class and as result from all questions
  'question':['visibleIf'];
  */
export const removeProperties = {
  survey: [
    'title',
    'description',
    'showTitle',
    'mode',
    'cookieName',
    'width',
    'logo',
    'logoWidth',
    'logoHeight',
    'logoFit',
    'firstPageIsStarted',
    'goNextPageAutomatic',
    'completedBeforeHtml',
    'maxTimeToFinish',
    'maxTimeToFinishPage',
    'showTimerPanel',
    'showTimerPanelMode',
    'minWidth',
  ],
  page: ['navigationDescription', 'maxTimeToFinish'],
  question: ['page', 'minWidth', 'indent', 'maxWidth', 'width'],
};

/*
  Hide properties from sidebar, but use default value of property in form.
  Hidden properties are setted as default in creatorJson object
  All properties are here: https://surveyjs.io/form-library/documentation/surveymodel#data
  */
export const hideProperties = {
  SurveyModel: [
    'locale',
    'showPreviewBeforeComplete',
    'pagePrevText',
    'pageNextText',
    'completeText',
    'previewText',
    'editText',
    'startSurveyText',
    'showNavigationButtons',
    'firstPageIsStarted',
    'goNextPageAutomatic',
    'showPrevButton',
    'showProgressBar',
    'progressBarType',
    'questionsOnPageMode', // DON'T REMOVE this prop because creates bug on tab visualization
    'questionTitleLocation',
    'questionDescriptionLocation',
    'questionTitlePattern',
    'requiredText',
    'questionErrorLocation',
    'showQuestionNumbers',
    'focusFirstQuestionAutomatic',
    'questionsOrder',
    'maxTextLength',
    'maxOthersLength',
    'autoGrowComment',
    'showPageTitles',
    'showPageNumbers',
    'clearInvisibleValues',
    'textUpdateMode',
    'sendResultOnPageNext',
    'storeOthersAsComment',
    'focusOnFirstError',
    'checkErrorsMode',
    'navigateToUrl',
    'showCompletedPage',
    'completedHtml',
    'completedHtmlOnCondition',
    'navigateToUrlOnCondition',
    'loadingHtml',
    'calculatedValues',
    'triggers',
  ],
  PageModel: [
    'questionTitleLocation',
    'questionDescriptionLocation',
    'questionsOrder',
    'navigationButtonsVisibility',
  ],
  PanelModel: [], //campo Gruppo di campi
  QuestionPanelDynamicModel: [], //campo Gruppo di campi dinamico
  QuestionTextModel: [
    'titleLocation',
    'descriptionLocation',
    'titlePattern',
    'page',
    'startWithNewLine',
    'state',
    'indent',
    'width',
    'minWidth',
    'maxWidth',
    'size',
    'clearIfInvisible',
    'textUpdateMode',
    'others',
  ], // campo Testo semplice
  QuestionCommentModel: [], //campo Casella di testo
  QuestionCheckboxModel: [], //campo Casella di controllo (checkbox)
  QuestionBooleanModel: [], //campo Booleano
  QuestionRadiogroupModel: [], //campo Opzione multipla (radio button)
  QuestionDropdownModel: [], //campo Tendina
  QuestionFileModel: [
    'showPreview',
    'imageHeight',
    'imageWidth',
    'allowImagesPreview',
  ], //campo File
  QuestionHtmlModel: [], //campo html
};
